import graphql from 'babel-plugin-relay/macro';
import {createMutation} from '@stackworx/relay';

import {LastPromptUpdateMutation} from './__generated__/LastPromptUpdateMutation.graphql';

const mutation = graphql`
  mutation LastPromptUpdateMutation($input: LastPromptUpdateInput!) {
    lastPromptUpdate(input: $input) {
      clientMutationId
    }
  }
`;

export const LastPromptUpdate = createMutation<LastPromptUpdateMutation>(
  mutation
);
